<div class="birim-tur-tree-area">
    <div class="birim-tur-area">
        <dk-ct-gen-lookup
        [placeholder]="'Birim Türü'"
        [lookUpType]="'BYS_BIRIM_TUR'"
        labelMode="static"
        (valueChange)="valueChangeBirimTur($event)"
        ></dk-ct-gen-lookup>
    </div>
    <div class="birim-area">
        <dx-drop-down-box
         [placeholder]="isCheckBirimTur?'Birim Türü Seçiniz':'Birim Seçiniz...'"
        valueExpr="Kod"
        displayExpr="Ad"
        [disabled]="isCheckBirimTur"
        [(opened)]="isTreeBoxOpened" [dataSource]="dataSource" [value]="selectedBirim.Kod">
            <dx-tree-view
                            id="treeViewBox"
                            [searchEnabled]="true"
                            [dataSource]="dataSource"
                            searchMode="startswith"
                            [height]="360"
                            dataStructure="plain"
                            keyExpr="Kod"
                            displayExpr="Ad"
                            parentIdExpr="AnaBirimKod"
                            itemTemplate="birimTemplate">
                            <div class="birim-item" *dxTemplate="let item of 'birimTemplate'" (click)="selectedRowData(item)">
                                {{ item.Ad  }} <i *ngIf="item.AnaBirimKod" class="dx-icon-favorites"></i>
                            </div>
                        </dx-tree-view>
        </dx-drop-down-box>
    </div>
    <div *ngIf="isShowBtn && belgeKod" class="popup-btn">
        <dx-button stylingMode="contained" type="normal"  icon="exportselected" width="100%"
        (onClick)="openList()">
    </dx-button>
    </div>
</div>

<dx-load-panel #loadPanel container="#treeViewBox" [showIndicator]="true" shadingColor="rgba(255,255,255)"
[showPane]="true" [shading]="false" [visible]="isLoading" [position]="{ of: '#treeViewBox' }"></dx-load-panel>

<ng-container *ngIf="isIcBirimlerDagitOpen">
  
    <dx-popup height="65%" width="40%" [showTitle]="true" [title]="'İç Birimlere Dağıt'" [resizeEnabled]="true"
        [hideOnOutsideClick]="false" [showCloseButton]="true" container=".dx-viewport"
        [(visible)]="isIcBirimlerDagitOpen">
        <dxo-position at="center" my="center" [of]="'icerikTasi'" collision="fit">
        </dxo-position>

        <div class="popup-content-area">
            <div class="popup-content-area-item">

              <div  class="islemler-area">
                <div class="info-text">
                    <span>Birimleri Seçiniz...</span>
                </div>
                <div class="widget-container">
                    <dx-list
                    #bilgiList
                    [dataSource]="icBirimlerList"
                    [allowItemDeleting]="false"
                    selectionMode="all"
                    selectAllMode="allPages"
                    [selectByClick]="true"
                    height="90%"
                    [searchEnabled]="true"
                    searchExpr="BirimAdi"
                    searchMode="contains"
                    (onSelectionChanged)="selectionBirimList($event)"
                    [showSelectionControls]="true"
                  >
                    <div *dxTemplate="let data of 'item'; let last = last" class="dx-list-item-area"   title="Dağıt">
                        <div class="title-area">
                            {{ data.BirimKodu }} - {{ data.BirimAdi }}
                        </div>
                        <!-- <dx-check-box
                        [value]="getBilgiCheckBox"
                        [elementAttr]="{ 'aria-label': 'Bilgi' }"
                      ></dx-check-box> -->

                    </div>
                  </dx-list>
                </div>
            </div>
              <div class="bottom-btn-area">
                <dx-button stylingMode="contained" text="Bilgi İçin Kaydet" type="default" (onClick)="bilgiBirimKaydet()">
                </dx-button>
                <dx-button stylingMode="contained" text="Gereği İçin Kaydet" type="success" (onClick)="geregiBirimKaydet()">
                </dx-button>
              </div>
            </div>
        </div>


    </dx-popup>

</ng-container>

